/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wry_Safe_Lark_LurkInputs */

const en_wry_safe_lark_lurk = /** @type {(inputs: Wry_Safe_Lark_LurkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const de_wry_safe_lark_lurk = /** @type {(inputs: Wry_Safe_Lark_LurkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Wry_Safe_Lark_LurkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wry_safe_lark_lurk = /** @type {((inputs?: Wry_Safe_Lark_LurkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wry_Safe_Lark_LurkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wry_safe_lark_lurk(inputs)
	return de_wry_safe_lark_lurk(inputs)
});